export const LOAN_RATE = 'rate'
export const AMOUNT = 'amount'
export const DURATION = 'duration'
export const CHECKBOX_CONFIRM = 'confirm'

export const CONFIRMATION_INITIAL_VALUES = {
  [CHECKBOX_CONFIRM]: false
}
